import ContactRequestModelBase from '../_generated/modelBases/contact-request-model-base';

export default class ContactRequestModel extends ContactRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
